<template>
  <section class="ClosingCta max-w-page">
    <h2 class="ClosingCta__heading">{{ heading }}</h2>
    <p class="ClosingCta__subtitle">{{ subtitle }}</p>
    <router-link :to="{ name: 'join' }" class="inline-block" title="Sign up">
      <AppButton primary class="ClosingCta__button">
        {{ buttonText }}
        <svg
          class="w-4 h-4 ml-2"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M4 12L12 4M6 4h6v6" />
        </svg>
      </AppButton>
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'ClosingCta',
  props: {
    heading: { type: String, default: 'Your next breakthrough is already in your data.' },
    subtitle: {
      type: String,
      default: 'Connect Strava or Garmin. FormBeat analyzes your history, finds the signal and shows you the next best move.'
    },
    buttonText: { type: String, default: 'Start your 30-day free trial' }
  }
}
</script>

<style lang="postcss" scoped>
/* Dark inset card with warm + green glows, floating on the light page background. */
.ClosingCta {
  @apply md:px-16 md:py-24 relative w-full px-8 py-16 mx-auto overflow-hidden text-center;
  background: radial-gradient(ellipse 60% 55% at 15% 0%, rgba(255, 89, 51, 0.25), transparent 70%),
    radial-gradient(ellipse 55% 45% at 50% 110%, rgba(74, 222, 128, 0.16), transparent 70%), #04141a;
  border-radius: 2.5rem;
}

/* Faint blueprint grid over the glows. */
.ClosingCta::before {
  @apply absolute inset-0 pointer-events-none;
  content: '';
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 56px 56px;
}

.ClosingCta__heading {
  @apply md:text-5xl relative max-w-2xl mx-auto mb-6 text-3xl font-bold leading-tight;
  color: #f4f1ea;
  letter-spacing: -0.02em;
}

.ClosingCta__subtitle {
  @apply relative max-w-xl mx-auto mb-10 text-lg text-gray-400;
}

.ClosingCta__button {
  @apply inline-flex items-center;
  box-shadow: 0 8px 32px rgba(255, 89, 51, 0.25);
}
</style>
